import "./scss/style.scss";
import "./js/lib/utils";
import addScript from "tartemeringuee/utils/addscript";
import Header from "./js/template-parts/common/header";
import ModulesLoader from "./js/modules-loader";

// Load objects
window.objectsLoaded = false;

function gtag() {
  dataLayer.push(arguments); // eslint-disable-line
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.objectsLoaded === false) {
    // Header
    window.header = new Header();

    // Google Tag Manager
    // eslint-disable-next-line
    if (typeof googleAnalyticsId !== "undefined" && googleAnalyticsId !== "") {
      // Define Google Tag Manager dataLayer and the gtag function.
      window.dataLayer = window.dataLayer || [];

      // Load Google Tag Manager.
      addScript(`//www.googletagmanager.com/gtm.js?id=${googleAnalyticsId}`); // eslint-disable-line
      gtag("js", new Date());
      gtag("config", googleAnalyticsId); // eslint-disable-line
    }
  }
});

window.addEventListener("load", () => {
  if (window.objectsLoaded === false) {
    window.captchaLoaded = false;
    window.googleapi = false;
    const libraries = {};

    // Modules loader
    try {
      window.modulesLoader = new ModulesLoader();
    } catch (error) {
      // code that changes the js body class to no-js
    }

    // BarbaJS
    libraries.barba = {
      fileName: "barba",
      cssClassName: ".barba-container",
    };

    // Load JS libraries
    window.loadJsLibraries(libraries);

    window.objectsLoaded = true;
  }
});
